const TITLE_SELECTOR = '.aviatrix-block--page-header .page-header__title';
const MIN_SCALE = 0.65;

function longestWordWidth(el) {
  const words = el.textContent.trim().split(/\s+/).filter(Boolean);

  if (!words.length) return 0;

  const probe = document.createElement('span');
  probe.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;pointer-events:none;';
  el.appendChild(probe);

  let widest = 0;
  words.forEach((word) => {
    probe.textContent = word;
    widest = Math.max(widest, probe.getBoundingClientRect().width);
  });

  probe.remove();

  return widest;
}

function fitTitle(el) {
  el.style.fontSize = '';

  const styles = window.getComputedStyle(el);
  const available =
    el.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);

  if (available <= 0) return;

  const widest = longestWordWidth(el);

  if (widest <= available) return;

  const scale = Math.max(available / widest, MIN_SCALE);
  el.style.fontSize = `${parseFloat(styles.fontSize) * scale}px`;
}

export default function initTitleFit() {
  document.addEventListener('DOMContentLoaded', () => {
    const titles = document.querySelectorAll(TITLE_SELECTOR);

    if (!titles.length) return;

    const fitAll = () => titles.forEach(fitTitle);

    fitAll();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAll);
    }

    let frame;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(fitAll);
    });
  });
}
